"use client";

import { QuantityStepper } from "@pamperedchef/design-system";

export interface QuantitySelectorProps {
	value: number;
	onChange: (value: number) => void;
	min?: number;
	max?: number;
	disabled?: boolean;
	description?: string;
	errorMessage?: string;
}

export function QuantitySelector({
	value,
	onChange,
	min = 1,
	max = 999,
	disabled = false,
	description,
	errorMessage
}: QuantitySelectorProps) {
	return (
		<QuantityStepper
			initialValue={value}
			min={min}
			max={max}
			onChange={onChange}
			disabled={disabled}
			description={description}
			errorMessage={errorMessage}
			size="lg"
		/>
	);
}
